import type { TransactionGstStatus } from '../types/transaction.types';

export function parseBusinessUsePercentInput(raw: string): number | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const value = Number(trimmed);
  if (Number.isNaN(value)) return null;
  return Math.min(100, Math.max(0, value));
}

export function claimableAmountAud(amount: number, businessUsePercent: number | null | undefined): number | null {
  if (businessUsePercent == null) return null;
  return (Math.abs(amount) * businessUsePercent) / 100;
}

export function gstStatusLabel(status: TransactionGstStatus | null | undefined): string {
  switch (status ?? 'unknown') {
    case 'includes_gst':
      return 'GST included';
    case 'no_gst':
      return 'No GST';
    default:
      return 'GST not verified';
  }
}
